import { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import { useNavigate } from 'react-router';

import { Box, Button, Card, CardContent, CardHeader, Chip, CircularProgress, Divider, FormControl, Grid, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';

import UndoIcon from '@mui/icons-material/Undo';

import moment from 'moment';
import 'moment/locale/es-mx';

import { DownloadFile } from '../../helpers/DownloadFile';
import { TablePaginationActions } from '../../helpers/TablePaginationActions';

import { usePages } from '../../hooks/usePages';

import { RootState } from '../../store';

import { TableTheadStyle, TablePaddingStyle } from '../../styles/TableStyle';

import { Layout } from '../../components/Layout';

import { DialogDocumento } from '../../dialogs/DialogDocumento';
import { DialogExpediente } from '../../dialogs/DialogExpediente';

import { ObtenerMateria } from '../../connections/catalogos/MateriaConnection';
import { ObtenerAutoridadesMaterias } from '../../connections/catalogos/AutoridadConnection';
import { ConsultarCertificaciones, DescargarCertificaciones } from '../../connections/tribunal/CertificacionConnection';
import { BuscarUsuariosCertificacionAsignacion, BuscarUsuariosCertificacionElaboro } from '../../connections/admin/UsuarioConnection';

import { MateriaProps } from '../../interfaces/catalogos/MateriaInterface';
import { AutoridadProps } from '../../interfaces/catalogos/AutoridadInterface';
import { UsuarioCertificacionProps } from '../../interfaces/admin/UsuarioInterface';
import { ConsultarCertificacionesProps } from '../../interfaces/tribunal/CertificacionInteface';
import { defaultExpediente, ExpedienteProps } from '../../interfaces/recepcion/ExpedienteInterface';

export const CertificacionesPage = () => {

    const navigate = useNavigate();

    const { administrador, coordinador } = useSelector( ( state: RootState ) => state.auth );

    const [loading, setLoading] = useState( false );
    const [loadingSearch, setLoadingSearch] = useState( false );
    const [loadingDescargar, setLoadingDescargar] = useState( false );

    const [openDetalleExpediente, setOpenDetalleExpediente] = useState( false );
    const [expedienteSeleccionado, setExpedienteSeleccionado] = useState<ExpedienteProps>( defaultExpediente );

    const [recordCount, setRecordCount] = useState( 0 );

    const [materia, setMateria] = useState( 0 );
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const [autoridad, setAutoridad] = useState( 0 );
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );

    const [usuarioElaboro, setUsuarioElaboro] = useState( 0 );
    const [usuarioElaboroArray, setUsuarioElaboroArray] = useState<UsuarioCertificacionProps[]>( [] );

    const [usuarioAsignacion, setUsuarioAsignacion] = useState( 0 );
    const [usuarioAsignacionArray, setUsuarioAsignacionArray] = useState<UsuarioCertificacionProps[]>( [] );

    const [numeroExpediente, setNumeroExpediente] = useState( '' );

    const [rows, setRows] = useState<ConsultarCertificacionesProps[]>( [] );

    const [openDocumento, setOpenDocumento] = useState( false );
    const [documento, setDocumento] = useState( '' );

    const [filtroAplicado, setFiltroAplicado] = useState( false );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 10 );

    const handleClear = () => {

        setFiltroAplicado( false );

        setMateria( 0 );
        setAutoridad( 0 );
        setUsuarioElaboro( 0 );
        setUsuarioAsignacion( 0 );
        setNumeroExpediente( '' );

        setRows( [] );
        setRecordCount( 0 );

        resetPage();

    }

    const handleBuscar = async () => {

        setLoadingSearch( true );
        setFiltroAplicado( true );

        setRecordCount( 0 );
        resetPage();

    }

    const handleDescargar = async () => {

        setLoadingDescargar( true );

        await DescargarCertificaciones({
            idAutoridad: autoridad,
            idMateria: materia,
            idUsuarioElaboro: usuarioElaboro,
            idUsuarioAsignacion: usuarioAsignacion,
            numeroExpediente
        }).then( resp => {

            setTimeout(() => {

                if ( resp ) {

                    DownloadFile( `Certificaciones-${ Date.now() }.xlsx`, resp );
                    setLoadingDescargar( false );

                }
                else {

                    setLoadingDescargar( false );

                }

            }, 700);

        });

    }

    const handleOpenDetalleExpediente = ( expediente: ExpedienteProps ) => {

        setExpedienteSeleccionado( expediente );
        setOpenDetalleExpediente( true );

    };

    useEffect(() => {

        async function Obtener() {

            await ObtenerMateria().then( resp => {
                setMateriaArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await BuscarUsuariosCertificacionElaboro().then( resp => {
                setUsuarioElaboroArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await BuscarUsuariosCertificacionAsignacion().then( resp => {
                setUsuarioAsignacionArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            setAutoridad( 0 );
            setAutoridadArray( [] );

            if ( materia !== 0 ) {

                await ObtenerAutoridadesMaterias( materia ).then( resp => {
                    setAutoridadArray( resp );
                });

            }
        }

        Obtener();

    }, [ materia ]);

    useEffect(() => {

        async function Obtener() {

            setLoading( true );
            setRows( [] );

            await ConsultarCertificaciones({
                page,
                rowsPerPage,
                idAutoridad: 0,
                idMateria: 0,
                idUsuarioElaboro: 0,
                idUsuarioAsignacion: 0,
                numeroExpediente: '',
            }).then( resp => {

                setTimeout(() => {

                    setRecordCount( resp.recordsCount );
                    setRows( resp.records );

                    setLoadingSearch( false );
                    setLoading( false );

                }, 700);

            });

        }

        if ( !filtroAplicado ) {
            Obtener();
        }

    }, [ page, rowsPerPage, filtroAplicado ]);

    useEffect(() => {

        async function Obtener() {

            setLoading( true );
            setRows( [] );

            await ConsultarCertificaciones({
                page,
                rowsPerPage,
                idAutoridad: autoridad,
                idMateria: materia,
                idUsuarioElaboro: usuarioElaboro,
                idUsuarioAsignacion: usuarioAsignacion,
                numeroExpediente
            }).then( resp => {

                setTimeout(() => {

                    setRecordCount( resp.recordsCount );
                    setRows( resp.records );

                    setLoadingSearch( false );
                    setLoading( false );

                }, 700);

            });

        }

        if ( filtroAplicado ) {
            Obtener();
        }

    }, [ page, rowsPerPage, filtroAplicado, materia, autoridad, usuarioElaboro, usuarioAsignacion, numeroExpediente ]);

    return (
        <Layout breadcrumbs={ [{ text: 'Consultas' }, { text: 'Certificaciones' }] } backgroundPaper={ false }>

            <Grid container spacing={ 3 }>

                {
                    ( administrador || coordinador )
                    &&
                        <Grid size={{ md: 12, xs: 12 }} textAlign={ 'start' }>

                            <Button startIcon={ <UndoIcon /> } color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate('/') }>
                                Regresar
                            </Button>

                        </Grid>
                }

                <Grid size={{ md: 12, xs: 12 }}>

                    <Card>
                        <CardHeader
                            sx={{ backgroundColor: (theme) => theme.palette.primary.main, py: 2 }}
                            subheader={ <Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Filtro(s) </Typography> }
                        />

                        <Divider />

                        <CardContent sx={{ p: 3 }}>

                            <Grid container spacing={ 3 }>

                                <Grid size={{ md: 2, xs: 12 }}>
                                    <FormControl fullWidth>
                                        <InputLabel>Materia</InputLabel>
                                        <Select
                                            label='Materia'
                                            value={ materia }
                                            onChange={ (e) => setMateria( e.target.value ) }
                                            disabled={ filtroAplicado }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                materiaArray
                                                .filter( ({ idMateria }) => idMateria === 5 || idMateria === 6 )
                                                .map(({ idMateria, descripcion }) => (
                                                    <MenuItem key={ idMateria } value={ idMateria }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{ md: 4, xs: 12 }}>
                                    <FormControl fullWidth>
                                        <InputLabel>Autoridad</InputLabel>
                                        <Select
                                            label="Autoridad"
                                            value={ autoridad }
                                            onChange={ (e) => setAutoridad( e.target.value ) }
                                            disabled={ filtroAplicado || materia === 0 }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                autoridadArray.map( ({ idAutoridad, descripcion }) => (
                                                    <MenuItem key={ idAutoridad } value={ idAutoridad }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>
                                    <TextField
                                        fullWidth
                                        label='Número de expediente'
                                        placeholder={ `1/${ new Date().getFullYear() }` }
                                        autoComplete='off'
                                        variant='outlined'
                                        value={ numeroExpediente }
                                        onChange={ (e) => setNumeroExpediente( e.target.value ) }
                                        disabled={ filtroAplicado }
                                        slotProps={{
                                            input: { autoComplete: 'off' },
                                            inputLabel: { shrink: true }
                                        }}
                                    />
                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>
                                    <FormControl fullWidth>
                                        <InputLabel>Usuario elaboró</InputLabel>
                                        <Select
                                            label="Usuario elaboró"
                                            value={ usuarioElaboro }
                                            onChange={ (e) => setUsuarioElaboro( e.target.value ) }
                                            disabled={ filtroAplicado }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                usuarioElaboroArray.map( ({ id, nombreCompleto }) => (
                                                    <MenuItem key={ id } value={ id }>{ nombreCompleto }</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>
                                    <FormControl fullWidth>
                                        <InputLabel>Usuario asignado</InputLabel>
                                        <Select
                                            label="Usuario asignado"
                                            value={ usuarioAsignacion }
                                            onChange={ (e) => setUsuarioAsignacion( e.target.value ) }
                                            disabled={ filtroAplicado }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                usuarioAsignacionArray.map( ({ id, nombreCompleto }) => (
                                                    <MenuItem key={ id } value={ id }>{ nombreCompleto }</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{ md: 9, xs: 12 }} textAlign={ 'end' }>
                                    <Button
                                        color={ filtroAplicado ? 'secondary' : 'primary' }
                                        variant={ filtroAplicado ? 'outlined' : 'contained' }
                                        loading={ loadingSearch }
                                        disabled={ (!filtroAplicado && (materia === 0 && autoridad === 0 && usuarioElaboro === 0 && usuarioAsignacion === 0 && numeroExpediente === '')) }
                                        onClick={ () => { filtroAplicado ? handleClear() : handleBuscar() } }
                                    >
                                        { filtroAplicado ? 'Limpiar filtro' : 'Buscar' }
                                    </Button>
                                </Grid>
                            </Grid>

                        </CardContent>

                    </Card>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }} textAlign={ 'right' }>

                    <Button
                        color='secondary'
                        variant="outlined"
                        sx={{ mt: 1 }}
                        loading={ loadingDescargar }
                        disabled={ rows.length === 0 }
                        onClick={ handleDescargar }
                    >
                        Descargar información
                    </Button>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }}>

                    <TableContainer sx={{ borderRadius: 3 }} component={ Paper }>

                        <Table sx={{ minHeight: rows.length === 0 ? 450 : 0 }}>

                            <TableHead sx={{ ...TableTheadStyle }}>

                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}></TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Expediente</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Certificación</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold' }}>Usuario elaboró</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold', textAlign: 'center' }}>Estatus</TableCell>

                                </TableRow>

                            </TableHead>

                            <TableBody>

                                {
                                    rows.map( ( { numeroSeguimiento, numeroExpediente, expediente, fechaCertificacion, usuarioCertifico, usuarioAsignado, documentoCertificacion, estatus, idEstatus }, index ) => (

                                        <TableRow key={ index } sx={{ '& td': { py: 2 } }}>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Typography variant='h6'>
                                                    { numeroSeguimiento }
                                                </Typography>

                                                <Typography variant='subtitle1' fontSize={ 14 }>
                                                    { fechaCertificacion ? moment( fechaCertificacion ).format( 'DD-MM-YYYY' ) : '' }
                                                </Typography>

                                                <Typography variant='caption' color='text.secondary'>
                                                    { fechaCertificacion ? moment( fechaCertificacion ).format( 'hh:mm a' ) : '' }
                                                </Typography>

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                {
                                                    numeroExpediente
                                                    &&
                                                        <Button
                                                            fullWidth
                                                            variant='contained'
                                                            onClick={ () => handleOpenDetalleExpediente( expediente ) }
                                                        >
                                                            { numeroExpediente }
                                                        </Button>
                                                }

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                {
                                                    documentoCertificacion
                                                    &&
                                                        <Button
                                                            fullWidth
                                                            variant='contained'
                                                            onClick={ () => {
                                                                setDocumento( documentoCertificacion );
                                                                setOpenDocumento( true );
                                                            }}
                                                        >
                                                            Ver
                                                        </Button>
                                                }

                                            </TableCell>

                                            <TableCell>

                                                <Typography variant='subtitle1' fontSize={ 14 }>
                                                    { usuarioCertifico }
                                                </Typography>

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Chip
                                                    variant='filled'
                                                    sx={{ fontWeight: 'bold' }}
                                                    color={ idEstatus === 3 ? 'primary' : 'default' }
                                                    label={
                                                        <Typography variant='subtitle1' fontWeight={ '600' } fontSize={ 13 }>
                                                            { estatus }
                                                        </Typography>
                                                    }
                                                />

                                                {
                                                    usuarioAsignado
                                                    &&
                                                        <Box sx={{ mt: 1 }}>

                                                            <Typography variant='caption' sx={{ fontWeight: 'bold', display: 'block', color: 'text.secondary' }}>
                                                                Asignado a:
                                                            </Typography>

                                                            <Typography variant='caption' sx={{ display: 'block', color: 'text.secondary', textTransform: 'uppercase', fontSize: 11 }}>
                                                                {usuarioAsignado}
                                                            </Typography>

                                                        </Box>
                                                }

                                            </TableCell>

                                        </TableRow>

                                    ))
                                }

                                {
                                    ( rows.length === 0 && !loading )
                                    ?
                                        <TableRow style={{ height: 100 }}>
                                            <TableCell colSpan={ 6 } align="center">
                                                <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>
                                            </TableCell>
                                        </TableRow>
                                    :
                                        loading
                                        &&
                                            <TableRow style={{ height: 100 }}>
                                                <TableCell colSpan={ 6 } align="center">
                                                    <CircularProgress size={ 26 } />
                                                </TableCell>
                                            </TableRow>
                                }

                            </TableBody>

                            <TableFooter>

                                <TableRow>

                                    <TableCell colSpan={ 2 }>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de registros: { recordCount } </Typography>
                                    </TableCell>

                                    <TablePagination
                                        rowsPerPageOptions={ [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500 ] }
                                        colSpan={ 4 }
                                        count={ recordCount }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }
                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }
                                        ActionsComponent={ TablePaginationActions }
                                        labelRowsPerPage="Filas por página"
                                        labelDisplayedRows={ ({ from, to, count }) => `${from}-${to} de ${count}` }
                                    />

                                </TableRow>

                            </TableFooter>

                        </Table>

                    </TableContainer>

                </Grid>

            </Grid>

            <DialogDocumento
                documento={ documento }
                openDialog={ openDocumento }
                handleCloseDialog={ () => setOpenDocumento( false ) }
            />

            <DialogExpediente
                expediente={ expedienteSeleccionado }
                openDialog={ openDetalleExpediente }
                handleCloseDialog={ () => setOpenDetalleExpediente( false ) }
            />

        </Layout>
    );
};
